import { Trans } from '@lingui/macro';
import { CONFIRM_PASSWORD_FIELD, PASSWORD_FIELD } from './UserConstants';
import PasswordRequirements from './PasswordRequirements';
import NgpPasswordField from '../../form/NgpPasswordField';

export default function UserPasswordSection({ showPassword }) {
    return (
        <>
            {showPassword && (
                <>
                    <PasswordRequirements />

                    <NgpPasswordField
                        fieldName={PASSWORD_FIELD}
                        label={<Trans>Password</Trans>}
                        required
                        inputProps={{ size: 65, maxLength: 65 }}
                    />

                    <NgpPasswordField
                        fieldName={CONFIRM_PASSWORD_FIELD}
                        label={<Trans>Confirm Password</Trans>}
                        required
                        inputProps={{ size: 65, maxLength: 65 }}
                    />
                </>
            )}
        </>
    );
}
